import $ from 'jquery';

$( '.c-offcanvas__nav__link' ).on( 'click', function() {
	$( '.c-hamburger-icon' ).toggleClass( 'is-active' );
} );
